import { Component, computed, DestroyRef, OnInit, inject } from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";
import { BasemapService } from "../../basemap/basemap.service";
import { DataModeService } from "../data-mode.service";
import { TranslocoPipe } from "@jsverse/transloco";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslocoDecimalPipe } from "@jsverse/transloco-locale";

@Component({
  selector: "app-task-info",
  templateUrl: "./task-info.component.html",
  styleUrls: ["./task-info.component.scss"],
  animations: [
    trigger("enterMenu", [
      transition(":enter", [style({ opacity: 0 }), animate(500, style({ opacity: 1 }))]),
      transition(":leave", [animate(300, style({ opacity: 0 }))])
    ])
  ],
  imports: [TranslocoPipe, TranslocoDecimalPipe]
})
export class TaskInfoComponent implements OnInit {
  baseMapService = inject(BasemapService);
  dataModeService = inject(DataModeService);
  private destroyRef = inject(DestroyRef);

  country = "DE";

  readonly currentYear = new Date().getFullYear();

  ngOnInit() {
    this.baseMapService.country.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(country => {
      this.country = country;
    });
  }

  // Get name for selected mode
  selectedDataModeName = computed(() => {
    const selectedDatamode = this.dataModeService.selectedDataMode();

    if (!selectedDatamode) {
      return "Module.Menu.Taskbar.TaskInfo.DefaultMode";
    } else {
      return "Title.MainTitle." + selectedDatamode.module + ".ModuleName";
    }
  });
}
